import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import axios from './utils/request'
import vueMeta from 'vue-meta'
import './style/resrt.css'
import './style/iconfont.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'

Vue.use(vueMeta, {
  refreshOnceOnNavigation: true
})

Vue.prototype.$request = axios

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0

  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
